
/**
 * Helper to format textes
 */
export class FormatHelper {

    /**
     * Format provided timestamp as Bot Server expects.
     * 
     * @param date - The date instance to format.
     */
    public static formatDateForBotServer(date: Date) {
        let hours: number  = date.getHours();
        let minutes: string | number = date.getMinutes();
        const ampm: string = hours >= 12 ? 'pm' : 'am';
        
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        const strTime: string = hours + ':' + minutes + ' ' + ampm;
        return date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
    }
}
